import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { AssignmentMove } from '../../core/assignment/assignment.types';
import { ModalComponent } from '../modal/modal';

/** Every move of who is dealing with an application, newest first. Read-only. */
@Component({
  selector: 'app-assignment-history-dialog',
  imports: [DatePipe, ModalComponent],
  template: `
    <app-modal heading="Who has dealt with this application">
      <ol class="history" data-testid="assignment-history">
        @for (move of history; track move.created_at) {
          <li>
            <span class="history__move">
              {{ move.from_user?.name ?? 'Nobody' }} → {{ move.to_user?.name ?? 'Nobody' }}
            </span>
            <span class="history__meta">
              by {{ move.changed_by.name }} · {{ move.created_at | date: 'medium' }}
            </span>
            @if (move.reason) {
              <span class="history__reason">{{ move.reason }}</span>
            }
          </li>
        }
      </ol>
    </app-modal>
  `,
  styles: `
    .history {
      display: grid;
      gap: var(--space-4);
      margin: 0;
      padding: 0;
      list-style: none;
      font-size: var(--font-size-sm);

      li {
        display: grid;
        gap: var(--space-1);
      }
    }

    .history__move {
      color: var(--foreground);
      font-weight: 600;
    }

    .history__meta,
    .history__reason {
      color: var(--muted-foreground);
    }

    .history__reason {
      font-style: italic;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssignmentHistoryDialogComponent {
  protected readonly history = inject<AssignmentMove[]>(MAT_DIALOG_DATA);
}
